import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";

@Injectable({ providedIn: 'root' })
export class TopbarDetailsService {
  public topbar_info = new BehaviorSubject('');
  public update_list = new BehaviorSubject(false);
  private coachDetailsSubject = new BehaviorSubject<any>(null);
  coachDetails$ = this.coachDetailsSubject.asObservable();
  public topbar_translation_key = new BehaviorSubject<{ key: string, params?: any }>({ key: '' });

  constructor() { }

  putTopbarTranslationKey(key: string, params?: any) {
    this.topbar_translation_key.next({ key, params });
  }

  getTopbarTranslationKey() {
    return this.topbar_translation_key;
  }

  getTopbarInfo() {
    return this.topbar_info;
  }

  updateListByObservable(flag) {
    this.update_list.next(flag);
  }

  setCoachDetails(details: any) {
    this.coachDetailsSubject.next(details);
  }
}
